import { makeAutoObservable } from "mobx";

import { companyFormToCompanyUpdateData } from "helpers/forms/incorporation/company";
import type { CompanyFormValues } from "helpers/forms/incorporation/companyTypes";
import { CompanyStore } from "services/company/companyStore";
import { CompanyProductsStore } from "services/companyProducts/companyProductsStore";
import { CompanyProduct, type DefaultCompanyProductDetailsData } from "services/companyProducts/companyProductsTypes";

export enum InitStepEntity {
  Name = "Name",
  SameDayRegistration = "SameDayRegistration",
}

export class InitStepStore {
  constructor(
    private readonly _companyStore: CompanyStore,
    private readonly _companyProductsStore: CompanyProductsStore,
  ) {
    makeAutoObservable(this);
  }

  async updateEntity(data: CompanyFormValues, entity: InitStepEntity): Promise<void> {
    switch (entity) {
      case InitStepEntity.Name:
        if (!this._companyStore.company) {
          await this._companyStore.createCompany(data.name, data.namePostfix);
          if (data.letterNoObjectionFileId) {
            await this._companyStore.updateName(data.name, data.namePostfix, data.letterNoObjectionFileId);
          }
        } else {
          await this._companyStore.updateName(data.name, data.namePostfix, data.letterNoObjectionFileId);
        }
        break;
      case InitStepEntity.SameDayRegistration:
        await this._updateProduct(CompanyProduct.SameDayRegistration, Boolean(data.sameDayRegistration));
        break;
      default:
        await this._companyStore.updateCompany(companyFormToCompanyUpdateData(data));
    }
  }

  private async _updateProduct(
    product: CompanyProduct,
    toggle: boolean,
    details?: DefaultCompanyProductDetailsData,
  ): Promise<void> {
    toggle
      ? await this._companyProductsStore.addProduct(product, details)
      : await this._companyProductsStore.deleteProduct(product);
  }
}
